import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getPlatform, getRegion } from 'src/config/environment';
import { useUser } from 'src/hooks/use_auth';
import { UserRole } from 'src/types/user_roles';
import { getRoleDisplayName } from 'src/utils';
import { logout } from 'src/utils/auth_utils';

// ProfileDropdown component now uses auth store directly - no props needed
const StyledProfileDropdown = styled(Box)(({ theme }) => ({
  width: 260,
  height: 186,
  borderRadius: 10,
  paddingBottom: theme.spacing(2),
  boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.14)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.background.paper,
}));

const Header = styled(Box)(({ theme }) => ({
  borderRadius: '10px 10px 0 0',
  height: 66,
  width: '100%',
  backgroundColor: theme.palette.primary.light,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

const HeaderTitle = styled('span')(({ theme }) => ({
  fontSize: theme.typography.caption.fontSize,
  lineHeight: '1.22',
  fontWeight: 600,
  textTransform: 'uppercase',
  color: theme.palette.common.black,
}));

const HeaderSubtitle = styled('span')(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  lineHeight: '1.4',
  fontSize: theme.typography.body1.fontSize,
  fontWeight: 600,
  textTransform: 'capitalize',
  color: theme.palette.common.black,
}));

const Body = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.text.primary,
}));

const BodyEmail = styled('span')(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 600,
  lineHeight: '1.22',
  textAlign: 'center',
}));

const BodyRole = styled('span')(({ theme }) => ({
  marginTop: theme.spacing(1),
  fontSize: theme.typography.caption.fontSize,
  fontWeight: 400,
  textTransform: 'capitalize',
  lineHeight: '1.22',
  color: theme.palette.text.primary,
}));

const Footer = styled(Box)({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'center',
});

export const ProfileDropdown: React.FC = () => {
  const user = useUser();

  // Filter out the Post RP Enabled role because it's hidden from the UI.
  const roles = user.roles.filter((role) => role != UserRole.PostRpEnabled);

  const handleLogout = () => {
    logout();
  };

  return (
    <StyledProfileDropdown>
      <Header>
        <HeaderTitle>My Organization</HeaderTitle>
        <HeaderSubtitle>{user.orgDisplayName}</HeaderSubtitle>
      </Header>
      <Body>
        <BodyEmail>{user.email}</BodyEmail>
        <BodyRole>
          {roles.length > 0
            ? getRoleDisplayName(roles[0], getPlatform(), getRegion())
            : 'No Role'}
        </BodyRole>
      </Body>
      <Footer>
        <Button onClick={handleLogout} variant='contained' size='medium'>
          LOG OUT
        </Button>
      </Footer>
    </StyledProfileDropdown>
  );
};
